module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.hasProductDetail) ? _c('div', [_c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "margin": "3px",
      "box-sizing": "border-box"
    },
    attrs: {
      "src": _vm.detailImgs[0],
      "alt": "img"
    }
  })])]) : _c('div', [(_vm.product.classificationCode === 'PS' || _vm.product.classificationCode === 'IC') ? _c('div', [_c('div', {
    staticClass: "ps_1"
  }, [_c('div', {
    staticClass: "ps_con"
  }, [_c('h3', [_vm._v("高标准商标宝")]), _vm._v(" "), _c('h4', [_vm._v("全方位助力企业发展")]), _vm._v(" "), _c('p', [_vm._v("一站式超值服务")])]), _vm._v(" "), _c('div', {
    staticClass: "ps_2"
  }, [_c('h2', [_vm._v("全面提升服务")]), _vm._v(" "), _c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/gsfw_1.png",
      "alt": "qsfw"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("快速")]), _vm._v(" "), _c('p', [_vm._v("下单后即刻得到响应")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/gsfw_2.png",
      "alt": "qsfw"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("安全")]), _vm._v(" "), _c('p', [_vm._v("下单后即刻得到响应")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/gsfw_3.png",
      "alt": "qsfw"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("专业")]), _vm._v(" "), _c('p', [_vm._v("下单后即刻得到响应")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/gsfw_4.png",
      "alt": "qsfw"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("无忧")]), _vm._v(" "), _c('p', [_vm._v("下单后即刻得到响应")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/gsfw_5.png",
      "alt": "qsfw"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("精准")]), _vm._v(" "), _c('p', [_vm._v("下单后即刻得到响应")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/gsfw_6.png",
      "alt": "qsfw"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("全面")]), _vm._v(" "), _c('p', [_vm._v("下单后即刻得到响应")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.product.classificationCode === 'FC') ? _c('div', [_c('div', {
    staticClass: "fc_1"
  }, [_c('div', {
    staticClass: "fc_con"
  }, [_c('h5', [_vm._v("企业湾为您解决全面财务问题")]), _vm._v(" "), _c('h3', [_vm._v("专业代理记账服务、合理发展企业财务")]), _vm._v(" "), _c('p', [_vm._v("保障信息安全 / 节约企业成本 / 专业服务 / 规避财务纠纷")])])]), _vm._v(" "), _c('div', {
    staticClass: "fc_2"
  }, [_c('h2', [_vm._v("代理记账对企业的好处")]), _vm._v(" "), _c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/cshc_1.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v("为您提供制度化服务")]), _vm._v(" "), _c('p', [_vm._v("总账会计、成本会计、费用会计等，\n              专业程度高，代理记账公司专业化")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/cshc_2.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v("降低成本，节省费用")]), _vm._v(" "), _c('p', [_vm._v("企业支付不到一个会计人员成本就可以\n              享受一个专业会计团队的服务")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/cshc_3.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v("多年财务经验，规避多重风险")]), _vm._v(" "), _c('p', [_vm._v("多年的经营经验，经历过多种突发事件，\n              可以说是经验丰富能够规避企业风险")])])])]), _vm._v(" "), _c('div', {
    staticClass: "fc_3"
  }, [_c('h2', [_vm._v("操作步骤")]), _vm._v(" "), _c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/cscz_1.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("在线下单")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/cscz_2.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("申请登记")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/cscz_3.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("税种核定")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/cscz_4.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("签订协议")])])])])]) : _vm._e(), _vm._v(" "), (_vm.product.classificationCode === 'QF') ? _c('div', [_c('div', {
    staticClass: "qf_1"
  }, [_c('img', {
    staticStyle: {
      "padding": "3px",
      "width": "100%"
    },
    attrs: {
      "src": "//v3.cdn.qiyewan.com/product-QF-1-pp.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "qf_2"
  }, [_c('h2', [_vm._v("企业具备的条件")]), _vm._v(" "), _c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/zztj_1.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("符合国家规定，依照法定\n              程序批准设立的机构")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/zztj_2.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("有固定的工作场所和从事通信工程\n              建设监理所需的设备")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/zztj_3.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("实行独立核算，自负盈亏\n              的独立法人实体")])])])])]) : _vm._e(), _vm._v(" "), (_vm.product.classificationCode === 'LD') ? _c('div', [_c('div', {
    staticClass: "ld_1"
  }, [_c('div', {
    staticClass: "ld_con"
  }, [_c('h5', [_c('span', [_vm._v("法律服务")]), _vm._v("是公司安全的重要基石")]), _vm._v(" "), _c('h3', [_vm._v("线上下单，专业人员一对一办理，从始至终的客户第一的态度")]), _vm._v(" "), _c('p', [_vm._v("Legal service is an important cornerstone of company safety\n            ornerstone of company safety")])])]), _vm._v(" "), _c('div', {
    staticClass: "ld_2"
  }, [_c('h2', [_vm._v("法律服务对公司的帮助")]), _vm._v(" "), _c('ul', [_c('li', [_c('h3', [_vm._v("用法律制度保护权益")]), _vm._v(" "), _c('p', [_vm._v("保护公司权益不受侵害 "), _c('br'), _vm._v("\n              当公司权益受到侵犯时可以拿起法律武器 "), _c('br'), _vm._v("\n              无论什么时候都要拿起法律的武器")])]), _vm._v(" "), _c('li', [_c('h3', [_vm._v("高效精准节约时间成本")]), _vm._v(" "), _c('p', [_vm._v("保护公司权益不受侵害 "), _c('br'), _vm._v("\n              当公司权益受到侵犯时可以拿起法律武器 "), _c('br'), _vm._v("\n              无论什么时候都要拿起法律的武器\n            ")])]), _vm._v(" "), _c('li', [_c('h3', [_vm._v("制定合理制度让企业告诉发展")]), _vm._v(" "), _c('p', [_vm._v("保护公司权益不受侵害 "), _c('br'), _vm._v("\n              当公司权益受到侵犯时可以拿起法律武器 "), _c('br'), _vm._v("\n              无论什么时候都要拿起法律的武器")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ld_3"
  }, [_c('h2', [_vm._v("服务流程")]), _vm._v(" "), _c('div', {
    staticClass: "aummary"
  }, [_vm._v("各地因为政策不同，所需办理的流程时间也不相同")]), _vm._v(" "), _c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/falc_1.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("售前咨询")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/falc_2.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("在线下单")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/falc_3.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("律师沟通")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/falc_4.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("提供服务")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/falc_5.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("售后回访")])])])])]) : _vm._e(), _vm._v(" "), (_vm.product.classificationCode === 'IT') ? _c('div', [_c('div', {
    staticClass: "it_1"
  }, [_c('p', [_vm._v("门户网站是公司最好的展现形式，在企业湾专人全程办理，足不出户帮您搞定")])]), _vm._v(" "), _c('div', {
    staticClass: "it_2"
  }, [_c('h2', [_vm._v("服务流程")]), _vm._v(" "), _c('div', {
    staticClass: "summary"
  }, [_vm._v("多数主管税务机关要求企业提供软件著作权和软件登记检测报告")]), _vm._v(" "), _c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/itlc_1.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("在线下单")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/itlc_2.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("及时响应")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/itlc_3.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("快速交付")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/itlc_4.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("满意为止")])])])]), _vm._v(" "), _c('div', {
    staticClass: "it_3"
  }, [_c('h3', [_vm._v("企业湾")]), _vm._v(" "), _c('h5', [_vm._v("一站超值快速响应")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "what-need-panel"
  }, [_c('div', {
    staticClass: "what_tit"
  }, [_vm._v("准备什么材料呢？")]), _vm._v(" "), _c('ul', {
    staticClass: "what-need-list"
  }, _vm._l((_vm.whatNeed), function(item, index) {
    return _c('li', [_c('span', [_vm._v(_vm._s(index + 1) + " ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item))])])
  }))]), _vm._v(" "), (_vm.product.classificationCode === 'PS' || _vm.product.classificationCode === 'IC') ? _c('div', [_c('div', {
    staticClass: "ps_3"
  }, [_c('h2', [_vm._v("企业为什么要进行工商服务")]), _vm._v(" "), _c('ul', [_c('li', [_c('h3', [_vm._v("服务公开")]), _vm._v(" "), _c('p', [_vm._v("根据合同及服务须知严格操\n              作，也可根据客户情况按标\n              准注册时间和注册要求加急\n              特殊通道办理。")])]), _vm._v(" "), _c('li', [_c('h3', [_vm._v("价格透明")]), _vm._v(" "), _c('p', [_vm._v("明码实价，签订协议后不再\n              收取任何附加费用。")])]), _vm._v(" "), _c('li', [_c('h3', [_vm._v("程序便捷")]), _vm._v(" "), _c('p', [_vm._v("按照注销基本程序、企业完\n              备材料依次进行，方便快捷\n              ，节省时间。")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ps_4"
  }, [_c('h2', [_vm._v("企业湾一站超值快速响应")]), _vm._v(" "), _c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/gsxy_1.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v("超值价格")]), _vm._v(" "), _c('p', [_vm._v("服务价格公开透明，无\n              任何隐形消费")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/gsxy_2.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v("快速响应")]), _vm._v(" "), _c('p', [_vm._v("在线下单4小时响应，对\n              接流程专业、简约")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/gsxy_3.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v("服务专业")]), _vm._v(" "), _c('p', [_vm._v("专属顾问为您服务，资深\n              专家为您把脉，企业湾专\n              业自营团队为您企业保驾\n              护航")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/gsxy_4.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v("一站式服务")]), _vm._v(" "), _c('p', [_vm._v("工商、财税、法务、人事\n              、IT全覆盖，为您创业全\n              方位助力")])])])])]) : _vm._e(), _vm._v(" "), (_vm.product.classificationCode === 'FC') ? _c('div', [_c('div', {
    staticClass: "fc_4"
  }, [_c('img', {
    staticStyle: {
      "padding": "3px",
      "width": "100%"
    },
    attrs: {
      "src": "//v3.cdn.qiyewan.com/product-FC-4-pp.png"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.product.classificationCode === 'QF') ? _c('div', [_c('div', {
    staticClass: "fc_3"
  }, [_c('img', {
    staticStyle: {
      "padding": "3px",
      "width": "100%"
    },
    attrs: {
      "src": "//v3.cdn.qiyewan.com/product-QF-3-pp.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fc_4"
  }, [_c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/zzfw_1.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("专业的服务")]), _vm._v(" "), _c('p', [_vm._v("几十位资质服务相关的专家为您\n              提供专业的解答")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/zzfw_2.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("快速的响应")]), _vm._v(" "), _c('p', [_vm._v("在线下单4小时内，服务人员快\n              速对接，积极响应")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/zzfw_3.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("高效的流程")]), _vm._v(" "), _c('p', [_vm._v("一旦服务生成，流程迅速展开，\n              便捷、简约")])])])])]) : _vm._e(), _vm._v(" "), (_vm.product.classificationCode === 'IT') ? _c('div', [_c('div', {
    staticClass: "it_4"
  }, [_c('h3', [_vm._v("信赖企业湾")]), _vm._v(" "), _c('h5', [_vm._v("助您圆梦企业成功")])]), _vm._v(" "), _c('div', {
    staticClass: "it_5"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n              优势 "), _c('strong', [_vm._v("1")]), _vm._v(" "), _c('br'), _c('span', [_vm._v("A bargain price")])]), _vm._v(" "), _c('h3', [_vm._v("超值价格")]), _vm._v(" "), _c('p', [_vm._v("服务价格公开透明，无任何隐形消费")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/itys_1.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/itys_2.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n              优势 "), _c('strong', [_vm._v("2")]), _vm._v(" "), _c('br'), _c('span', [_vm._v("A quick response")])]), _vm._v(" "), _c('h3', [_vm._v("快速响应")]), _vm._v(" "), _c('p', [_vm._v("在线下单4小时响应，对接流程专业、简约")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n              优势 "), _c('strong', [_vm._v("3")]), _vm._v(" "), _c('br'), _c('span', [_vm._v("Professional service")])]), _vm._v(" "), _c('h3', [_vm._v("服务专业")]), _vm._v(" "), _c('p', [_vm._v("专属顾问为您服务，资深专家为您把脉，企业湾专业自营团队为您企业保驾护航")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/itys_3.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/itys_4.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n              优势 "), _c('strong', [_vm._v("4")]), _vm._v(" "), _c('br'), _c('span', [_vm._v("One-stop service")])]), _vm._v(" "), _c('h3', [_vm._v("一站式服务")]), _vm._v(" "), _c('p', [_vm._v("工商、财税、法务、人事、IT全覆盖，为您创业全方位助力")])])])])]) : _vm._e(), _vm._v(" "), (_vm.product.classificationCode === 'LD') ? _c('div', [_c('div', {
    staticClass: "ld_4"
  }, [_c('h2', [_vm._v("企业湾服务优势")]), _vm._v(" "), _c('ul', [_c('li', [_c('h3', [_vm._v("1.超值价格")]), _vm._v(" "), _c('p', [_vm._v("服务价格公开透明，无任何隐形消费")])]), _vm._v(" "), _c('li', [_c('h3', [_vm._v("2.快速响应")]), _vm._v(" "), _c('p', [_vm._v("在线下单4小时响应，对接流程专业、简约\n            ")])]), _vm._v(" "), _c('li', [_c('h3', [_vm._v("3.服务专业")]), _vm._v(" "), _c('p', [_vm._v("专属顾问为您服务，资深专家为您把脉，企业湾专业自营团队为您企业保驾护航")])]), _vm._v(" "), _c('li', [_c('h3', [_vm._v("4.一站式服务")]), _vm._v(" "), _c('p', [_vm._v("工商、财税、法务、人事、IT全覆盖，为您创业全方位助力")])])])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-5ead672e!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/ServiceDetail.vue
// module id = 1044
// module chunks = 40